import { DateTime } from 'luxon';
import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const USER_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;
const twoWeeksFromNow = DateTime.utc()
  .setZone(USER_TIMEZONE)
  .plus({ weeks: 2 })
  .toFormat(`yyyy-MM-dd'T'HH':'mm`);

const CreateCampaignModal = ({ show, onHide, onCreate }) => {
  const [name, setName] = useState('');
  const [expireAt, setExpireAt] = useState(twoWeeksFromNow);
  const [solLimit, setSolLimit] = useState('');

  const handleSubmit = async () => {
    let parsedSolLimit = null;
    const trimmedValue = solLimit.trim();

    if (trimmedValue !== '') {
      const numericValue = parseFloat(trimmedValue);

      if (Number.isNaN(numericValue) || numericValue < 0) {
        alert('SOL limit must be a non-negative number.');
        return;
      }

      parsedSolLimit = numericValue;
    }

    await onCreate({ name, expireAt, solLimit: parsedSolLimit });
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Create Campaign</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Campaign Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter campaign name"
              value={name}
              onChange={e => setName(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Expiration Date</Form.Label>
            <Form.Control
              type="datetime-local"
              defaultValue={expireAt}
              onChange={e => setExpireAt(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>SOL Limit (optional)</Form.Label>
            <Form.Control
              type="number"
              placeholder="Leave empty for unlimited"
              value={solLimit}
              onChange={e => setSolLimit(e.target.value)}
              min="0"
              step="0.01"
            />
            <Form.Text className="text-muted">
              Maximum total SOL that can be redeemed from this campaign
            </Form.Text>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Create Campaign
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateCampaignModal;
